/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
import { useContext, useEffect, useState } from "react";
import {
  MdCancel,
  MdClose,
  MdCreateNewFolder,
  MdDashboard,
  MdReport,
} from "react-icons/md";
import { BiCheckShield, BiLockAlt, BiLogOut, BiUser } from "react-icons/bi";
import {
  FaCashRegister,
  FaPlusCircle,
  FaRoute,
  FaStar,
  FaTicketAlt,
} from "react-icons/fa";
import { Link, useNavigate, NavLink } from "react-router-dom";
import {
  Menubar,
  MenubarMenu,
  MenubarTrigger,
  MenubarContent,
  MenubarItem,
  Separator,
  Avatar,
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuContent,
} from "@repo/ui";
import { ChevronDown, User2Icon } from "lucide-react";
import AuthContext from "store/auth-context";
import { useUser } from "hooks/use-user";
import { defaultFilters, FiltersContext } from "store/filters-context";
import Logo from "../assets/images/logo.png";
import { PATHS } from "../routes/paths";
import { isCallCenterAgent } from "pages/tickets/utils";
import { HoverDropdown } from "ui/hover-dropdown";
import { useGetSavedCriteria } from "services/dynamic-filtering";
import eventBus from "store/event-emitter";
const CREATE_TICKETS_TYPES = [
  {
    text: "Facilities Request",
    to: PATHS.createFacilityTickets,
  },
  {
    text: "Remote Support Request",
    to: PATHS.createRemoteSupportRequest,
  },
  {
    text: "Customer Complaint",
    to: PATHS.createCustomerComplaint,
  },
  {
    text: "Customer Service",
    to: PATHS.createCustomerService,
  },
  {
    text: "Etisalat Third Party",
    to: PATHS.createEtisalatThirdParty,
  },
  {
    text: "Unusual Event",
    to: PATHS.createUnusualEvent,
  },
  {
    text: "Panic Alert Incident",
    to: PATHS.createPanicAlertIncident,
  },
  {
    text: "Voice Of Staff",
    to: PATHS.createVoiceOfStaff,
  },
  {
    text: "TGSI Help Desk",
    to: PATHS.createTGSIHelpDesk,
  },
  {
    text: "Missed & Delayed Service",
    to: PATHS.createMissedDelayedService,
  },
  {
    text: "Marketing",
    to: PATHS.createMarketing,
  },
  {
    text: "Incident Reporting",
    to: PATHS.createAccidentIncidentReporting,
  },
];
const COMMAND_CENTER_ADMIN = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
];
const CALL_CENTER_AGENT = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaPlusCircle className="text-nav" />,
    text: "Create Ticket",
    to: PATHS.createTicket,
    subMenu: CREATE_TICKETS_TYPES.map((elm) => ({
      icon: <FaTicketAlt className="text-nav" />,
      text: elm.text,
      to: elm.to,
      subMenu: elm.subMenu,
    })),
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Calls",
    to: PATHS.allServiceAndNonServiceCalls,
  },

  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Quick Links",
    to: PATHS.allTickets,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Service Calls",
        to: PATHS.openTickets,
        subMenu: [
          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "All",
            to: PATHS.allTickets,
          },
          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "Open (Non Cash)",
            to: PATHS.openTickets,
          },
          {
            icon: <FaCashRegister className="text-nav" />,
            text: "Open (Cash)",
            to: PATHS.cashTickets,
          },

          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "Assigned",
            to: PATHS.assignedTickets,
          },
          {
            icon: <BiCheckShield className="text-nav" />,
            text: "Vault Access",
            to: PATHS.vaultAccessTickets,
          },
          {
            icon: <BiUser className="text-nav" />,
            text: "Resolved",
            to: PATHS.resolvedTickets,
          },
          {
            icon: <BiUser className="text-nav" />,
            text: "Awaiting",
            to: PATHS.awaitingTickets,
          },

          {
            icon: <MdClose className="text-nav" />,
            text: "Closed",
            to: PATHS.closedTickets,
          },
          {
            icon: <MdCancel className="text-nav" />,
            text: "Cancelled",
            to: PATHS.cancelledTickets,
          },
        ],
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "CCA Calls",
        to: PATHS.allCalls,
        subMenu: [
          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "All",
            to: PATHS.allCalls,
          },
          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "Open",
            to: PATHS.openCalls,
          },

          {
            icon: <FaTicketAlt className="text-nav" />,
            text: "Assigned",
            to: PATHS.assignedCalls,
          },

          {
            icon: <BiUser className="text-nav" />,
            text: "Resolved",
            to: PATHS.resolvedCalls,
          },

          {
            icon: <MdClose className="text-nav" />,
            text: "Closed Calls",
            to: PATHS.closedCalls,
          },
          {
            icon: <MdCancel className="text-nav" />,
            text: "Cancelled",
            to: PATHS.cancelledCalls,
          },
        ],
      },

      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Panic Alert Incidents",
        to: PATHS.panicAlertCalls,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Incident Reporting",
        to: PATHS.accidentIncidentCalls,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "My Tickets",
        to: PATHS.myCalls,
      },
    ],
  },

  {
    icon: <MdCreateNewFolder className="text-nav" />,
    text: "Bulk",
    to: PATHS.bulkOperation,
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
  // {
  //   icon: <FaTicketAlt className="text-nav" />,
  //   text: "Dynamic Filtering",
  //   to: PATHS.dynamicFiltering,
  // },
];

const CC_CALLS = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Calls",
    to: PATHS.allCalls,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Quick Links",
    to: PATHS.allCalls,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Open",
        to: PATHS.openCalls,
      },

      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Assigned",
        to: PATHS.assignedCalls,
      },

      {
        icon: <BiUser className="text-nav" />,
        text: "Resolved",
        to: PATHS.resolvedCalls,
      },

      {
        icon: <MdClose className="text-nav" />,
        text: "Closed",
        to: PATHS.closedCalls,
      },
      {
        icon: <MdCancel className="text-nav" />,
        text: "Cancelled",
        to: PATHS.cancelledCalls,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "My Tickets",
        to: PATHS.myCalls,
      },
    ],
  },

  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
];

const CALL_OUT_DISPATCHER = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Tickets",
    to: PATHS.allTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Open",
    to: PATHS.openTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Assigned",
    to: PATHS.assignedTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Gunnebo",
    to: PATHS.gunnebo,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Non Gunnebo",
    to: PATHS.nonGunnebo,
  },
  {
    icon: <BiUser className="text-nav" />,
    text: "My Tickets",
    to: PATHS.selfAssignedTickets,
  },
  {
    icon: <MdClose className="text-nav" />,
    text: "Closed",
    to: PATHS.closedTickets,
  },

  {
    icon: <FaRoute className="text-nav" />,
    text: "Routes",
    to: "/routes",
  },

  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Dynamic Filtering",
    to: PATHS.dynamicFiltering,
  },
];

const SLM_DISPATCHER = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Tickets",
    to: PATHS.allTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Open",
    to: PATHS.openTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Assigned",
    to: PATHS.assignedTickets,
  },
  {
    icon: <BiUser className="text-nav" />,
    text: "My Tickets",
    to: PATHS.selfAssignedTickets,
  },
  {
    icon: <MdClose className="text-nav" />,
    text: "Closed",
    to: PATHS.closedTickets,
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Dynamic Filtering",
    to: PATHS.dynamicFiltering,
  },
];
const CS_MONITORING = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All",
    to: PATHS.csMonitoringAllCalls,
  },

  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Open",
    to: PATHS.csMonitoringOpenCalls,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Assigned",
    to: PATHS.csMonitoringAssignedCalls,
  },

  {
    icon: <BiUser className="text-nav" />,
    text: "My Tickets",
    to: PATHS.csMonitoringSelfAssignedCalls,
  },
  {
    icon: <MdClose className="text-nav" />,
    text: "Closed",
    to: PATHS.csMonitoringClosedCalls,
  },

  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
];
const CSM_AGENT = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaPlusCircle className="text-nav" />,
    text: "Create Ticket",
    to: PATHS.createPanicAlertIncident,

    subMenu: [
      {
        text: "Panic Alert Incidents",
        to: PATHS.createPanicAlertIncident,
      },
      {
        text: "Incident Reporting",
        to: PATHS.createAccidentIncidentReporting,
      },
    ].map((elm) => ({
      icon: <FaTicketAlt className="text-nav" />,
      text: elm.text,
      to: elm.to,
      subMenu: elm.subMenu,
    })),
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Calls",
    to: PATHS.allServiceAndNonServiceCalls,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Quick Links",
    to: PATHS.panicAlertCalls,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Panic Alert Incidents",
        to: PATHS.panicAlertCalls,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Incident Reporting",
        to: PATHS.accidentIncidentCalls,
      },
    ],
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
    subMenu: [
      {
        icon: <MdReport className="text-nav" />,
        text: "Quick Reports",
        to: PATHS.reports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Ticket Reports",
        to: PATHS.serviceTicketReports,
      },
      {
        icon: <MdReport className="text-nav" />,
        text: "Task Reports",
        to: PATHS.generatedReport,
      },
    ],
  },
];
export default function Header() {
  const user = useUser();
  const isSLMEngineer = user.Roles.includes("SLM Engineer Dispatcher");
  const isCSMonitoring = user.Roles.includes("CS Monitoring");
  const isCCCalls = user.Roles.includes("CC Calls");
  const isCommandCenterAdmin = user.Roles.includes("CC Dashboard");
  const isLargeDataSetUser = user.Roles.includes("Large Data Set User");
  const isCCA = isCallCenterAgent(user);
  const isCSMAgent = user.Roles.includes("CSM Agent");
  const ticketsType = isCCA || isCCCalls || isCSMAgent ? "allcalls" : "tasks";

  const {
    mutate: getSaveCriteria,
    data: savedCriteria,
    reset: resetSavedCriteria,
  } = useGetSavedCriteria();
  const authCtx = useContext(AuthContext);
  const [allHeaderLinks, setAllHeaderLinks] = useState([]);
  const [navLinks, setNavLinks] = useState([]);
  const [menuLinks, setMenuLinks] = useState(null);
  const { setFilters } = useContext(FiltersContext);
  const navigate = useNavigate();

  const filterReportsMenu = (links) =>
    links.map((link) => {
      if (link.text === "Reports" && link.subMenu) {
        return {
          ...link,
          subMenu: link.subMenu.filter(
            (item) => item.text === "Quick Reports" || isLargeDataSetUser,
          ),
        };
      }
      return link;
    });

  useEffect(() => {
    let _links;
    if (isCommandCenterAdmin) {
      _links = COMMAND_CENTER_ADMIN;
    } else if (isCCCalls) {
      _links = CC_CALLS;
    } else if (isCCA) {
      _links = CALL_CENTER_AGENT;
    } else if (isCSMAgent) {
      _links = CSM_AGENT;
    } else if (isSLMEngineer) {
      _links = SLM_DISPATCHER;
    } else if (isCSMonitoring) {
      _links = CS_MONITORING;
    } else {
      _links = CALL_OUT_DISPATCHER;
    }
    setAllHeaderLinks(filterReportsMenu(_links));
    const handler = () => {
      getSaveCriteria(ticketsType);
    };
    if (
      user.Roles.includes("Call Out Dispatcher") ||
      user.Roles.includes("Call Center Agent") ||
      isCSMAgent ||
      isSLMEngineer
    ) {
      handler();
    }

    eventBus.on("refreshFavorites", handler);

    // Cleanup on unmount
    return () => {
      eventBus.off("refreshFavorites", handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (savedCriteria && allHeaderLinks.length > 0) {
      const _allHeaderLinks = [...allHeaderLinks];
      const existingFav = _allHeaderLinks.findIndex(
        (elm) => elm.text === "Favorites",
      );

      _allHeaderLinks.splice(
        isCCA || isCCCalls || isCSMAgent ? 3 : 2,
        existingFav === -1 ? 0 : 1,
        {
          icon: <FaStar className="text-nav" />,
          text: "Favorites",
          to:
            isCCA || isCCCalls || isCSMAgent
              ? PATHS.allServiceAndNonServiceCalls
              : PATHS.dynamicFiltering,
          subMenu: savedCriteria.data.map((elm) => ({
            icon: <FaTicketAlt className="text-nav" />,
            text: elm.searchName,
            to: `${isCCA || isCCCalls || isCSMAgent ? PATHS.allServiceAndNonServiceCalls : PATHS.dynamicFiltering}/${elm.id}`,
          })),
        },
      );
      setAllHeaderLinks(_allHeaderLinks);
      resetSavedCriteria();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedCriteria, allHeaderLinks]);

  useEffect(() => {
    const eventHandler = () => {
      const screenWidth = window.innerWidth;

      let visibleLinks = allHeaderLinks.length;

      if (screenWidth <= 1600) {
        visibleLinks = 7;
      } else if (screenWidth <= 1800) {
        visibleLinks = 10;
      } else if (screenWidth <= 2000) {
        visibleLinks = 13;
      }

      setNavLinks(allHeaderLinks.slice(0, visibleLinks));
      setMenuLinks(
        allHeaderLinks.length > visibleLinks
          ? allHeaderLinks.slice(visibleLinks)
          : null,
      );
    };

    eventHandler();

    window.addEventListener("resize", eventHandler);

    return () => {
      window.removeEventListener("resize", eventHandler);
    };
  }, [allHeaderLinks]);

  const handleLogout = () => {
    authCtx.logout();
  };
  const goToProfile = () => {
    navigate(PATHS.profile);
  };
  const goToChangePassword = () => {
    navigate(PATHS.changePassword);
  };

  return (
    <header className="bg-white shadow-lg fixed-header">
      <nav
        className=" flex  items-center  p-6 lg:px-6 lg:py-3.5 w-full"
        aria-label="Global"
      >
        <Link to="/">
          <img className="w-[65px]" src={Logo} alt="" />
        </Link>

        <Separator orientation="vertical" className="h-8 mx-8" />
        <div className="lg:flex gap-[25px] items-center">
          <NavigationMenu>
            <NavigationMenuList className="flex flex-row gap-2">
              {navLinks.map((elm, index) => {
                if (elm.subMenu) {
                  return (
                    <NavigationMenuItem key={index}>
                      <NavigationMenuTrigger style={{ height: "auto" }}>
                        {elm.to ? (
                          <NavLink
                            to={elm.to}
                            className="header-links"
                            onClick={() => {
                              setFilters({ ...defaultFilters });
                            }}
                          >
                            <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                              <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                                {elm.icon}
                              </div>
                              <div className="flex flex-row justify-center items-center">
                                <p className="text-primary text-sm">
                                  {elm.text}
                                </p>
                              </div>
                            </div>
                          </NavLink>
                        ) : (
                          <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                            <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                              {elm.icon}
                            </div>
                            <div className="flex flex-row justify-center items-center">
                              <p className="text-primary text-sm">{elm.text}</p>
                            </div>
                          </div>
                        )}
                      </NavigationMenuTrigger>
                      <NavigationMenuContent
                        dir="ventricle"
                        className="max-h-[70vh] overflow-y-scroll"
                      >
                        <ul className="p-2 w-[250px] ">
                          {elm.subMenu.map((subItem) => {
                            if (subItem.subMenu) {
                              return (
                                <HoverDropdown
                                  key={subItem.text}
                                  triggerComponent={<li>{subItem.text}</li>}
                                  list={subItem.subMenu}
                                  itemProps={{
                                    className:
                                      "w-full block text-sm hover:bg-secondary/20 rounded-md text-nowrap w-[200px]",
                                    onClick: () => {
                                      setFilters({ ...defaultFilters });
                                    },
                                  }}
                                />
                              );
                            }
                            return (
                              <li key={subItem.to}>
                                <Link
                                  onClick={() => {
                                    setFilters({ ...defaultFilters });
                                  }}
                                  className="w-full flex text-sm hover:bg-secondary/20 p-2 rounded-md text-wrap"
                                  to={subItem.to}
                                >
                                  {subItem.text}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      </NavigationMenuContent>
                    </NavigationMenuItem>
                  );
                }

                return (
                  <NavigationMenuItem key={index}>
                    <NavLink
                      to={elm.to}
                      className="header-links"
                      onClick={() => {
                        setFilters({ ...defaultFilters });
                      }}
                    >
                      <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                        <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                          {elm.icon}
                        </div>
                        <div className="flex flex-row justify-center items-center">
                          <p className="text-primary text-sm">{elm.text}</p>
                        </div>
                      </div>
                    </NavLink>
                  </NavigationMenuItem>
                );
              })}
            </NavigationMenuList>
          </NavigationMenu>
          {menuLinks ? (
            <Menubar>
              <MenubarMenu>
                <MenubarTrigger>More</MenubarTrigger>

                <MenubarContent>
                  {menuLinks?.map((elm, index) => (
                    <MenubarItem key={`${index}${elm.text}`}>
                      <Link
                        to={elm.to}
                        onClick={() => {
                          setFilters({ ...defaultFilters });
                        }}
                      >
                        <div className="flex flex-row justify-center items-center">
                          <p className="text-primary text-sm">{elm.text}</p>
                        </div>
                      </Link>
                    </MenubarItem>
                  ))}
                </MenubarContent>
              </MenubarMenu>
            </Menubar>
          ) : (
            <></>
          )}
        </div>

        <div className="flex items-center gap-4 ml-auto">
          <span className="uppercase text-sm">{user.DisplayName}</span>
          <Menubar className="border-none">
            <MenubarMenu>
              <MenubarTrigger>
                <Avatar
                  style={{
                    backgroundColor: "#c6c6c6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {/* <AvatarImage src="https://github.com/shadcn.png" /> */}
                  <User2Icon />
                  {/* <AvatarFallback>{user.DisplayName}</AvatarFallback> */}
                </Avatar>
              </MenubarTrigger>
              <MenubarContent>
                <MenubarItem className="gap-3" onClick={goToProfile}>
                  <BiUser />
                  Profile
                </MenubarItem>
                <MenubarItem className="gap-3" onClick={goToChangePassword}>
                  <BiLockAlt />
                  Change Password
                </MenubarItem>
                <MenubarItem className="gap-3" onClick={handleLogout}>
                  <BiLogOut />
                  Logout
                </MenubarItem>
              </MenubarContent>
            </MenubarMenu>
          </Menubar>
        </div>
      </nav>
    </header>
  );
}
